import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { API_URL, config } from '../components/Include';
import { Alerts } from '../components/notify';
import './Login.css';

const Login =()=> {
  const [applicant, setApplicant] = useState({
		password:'',
		matric_no:'',
		email_address:'',
    })

    const [errors, setErrors] = useState({
      errorMessage:'',
      email_address:'',
      password:'',
      matric_no:'',
      is_loading:false
  });


  const handleChange = (event:ChangeEvent<HTMLInputElement>) =>{	
    let {name, value} = event.target;	

    setApplicant({...applicant, [name] : value });
   setErrors({...errors, errorMessage:'', [name]:''});
}




const handleSubmit=(event: FormEvent<HTMLFormElement>)=>{
  event.preventDefault();

  let error = {...errors}; 
  let formIsValid = true;

let msg ='This field is required';

if(!applicant.matric_no){
  error.matric_no =msg;
  formIsValid = false;
}


if(!applicant.password){
  error.password =msg;
  formIsValid = false;
} 

if(!formIsValid){
  setErrors(error) 
  }

  if(formIsValid) {

    setErrors({...errors, is_loading:true})
  const fd = new FormData();
  Object.entries(applicant).forEach(([key, value]) => {
      fd.append(key, value);
  }); 
 

		let url = API_URL+'/student/login';
		axios.post(url, fd, config).then((response:any)=>{

			if(response.data.type ==='success'){
        Alerts('success', response.data.message, 'Weldone!')

       
  //1000 * 60 * SESSION_IDEL_MINUTES
  var inSixtyMinutes:any = Date.now() + 419 * 60 * 1000;
  var inOneMinutes:any = Date.now() + 418 * 60 * 1000;
    var inHours = new Date(new Date().getTime() + 419 * 60 * 1000);
    
     localStorage.setItem('_spexpt', inSixtyMinutes)
    localStorage.setItem('_spbexpt', inOneMinutes) 

  Cookies.set('app_spcd', response.data.code, {expires: inHours })
  Cookies.set('app_tcscdk', response.data.token, {expires: inHours })  

  window.open('/app/dashboard', '_self')
  
			}else{
        Alerts('danger', response.data.message, 'Something went wrong!')
        setApplicant({...applicant, password:''});

			}
	  })
		.catch((error)=>{
      Alerts('danger', error.message, 'Error')
		}).finally(()=>{
      setErrors({...errors, is_loading:false})
    })
    }

}

let stop:any = Date.now();

const clearCookies=()=>{
  Cookies.remove('app_tcscdk')
   Cookies.remove('app_spcd')	
localStorage.setItem('_spexpt', stop)
localStorage.setItem('_spbexpt', stop)
}

useEffect(()=>{
  clearCookies()
}, [])

  return (
    <section className="login-section py-5">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0 rounded-lg overflow-hidden">
              <div className="row g-0">
                {/* Left side - Information */}
                <div className="col-md-5 bg-primary text-white d-flex flex-column justify-content-center p-4">
                  <div className="text-center mb-4">
                    <img src="/images/logo.png" alt="EDC Logo" className="img-fluid mb-4" style={{ maxHeight: '80px' }} />
                    <h2 className="fw-bold mb-3">Student Login</h2>
                    <p className="lead mb-4">Access your educational resources and training</p>
                  </div>
                  
                  <div className="steps-container">
                    <div className="step-item d-flex align-items-center mb-4">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">1</div>
                      <div className="step-text">
                        <p className="mb-0">First, <a href="/register" className="text-white fw-bold">validate your studentship</a> to access the portal</p>
                      </div>
                    </div>
                    
                    <div className="step-item d-flex align-items-center mb-4">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">2</div>
                      <div className="step-text">
                        <p className="mb-0">Pay for your training manual before selecting your EDC Skill</p>
                      </div>
                    </div>
                    
                    <div className="step-item d-flex align-items-center">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">3</div>
                      <div className="step-text">
                        <p className="mb-0">Check your training schedule after login</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Right side - Login Form */}
                <div className="col-md-7 p-4 p-lg-5 position-relative">
                  {errors.is_loading && (
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                  
                  <div className="text-center mb-4">
                    <h2 className="fw-bold text-primary">Welcome Back</h2>
                    <p className="text-muted">Please sign in to continue to your account</p>
                  </div>
                  
                  <form onSubmit={handleSubmit}>
                    <div className="form-floating mb-4">
                      <input 
                        type="text" 
                        className={`form-control ${errors.matric_no ? 'is-invalid' : ''}`} 
                        id="matric_no"
                        name="matric_no" 
                        placeholder="Enter your matriculation number"
                        value={applicant.matric_no} 
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      <label htmlFor="matric_no">Matriculation Number</label>
                      {errors.matric_no && <div className="invalid-feedback">{errors.matric_no}</div>}
                    </div>
                    
                    <div className="form-floating mb-4">
                      <input 
                        type="password" 
                        className={`form-control ${errors.password ? 'is-invalid' : ''}`} 
                        id="password"
                        name="password" 
                        placeholder="Enter your password"
                        value={applicant.password} 
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      <label htmlFor="password">Password</label>
                      {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>
                    
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="rememberMe" />
                        <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
                      </div>
                      <a href="/forgot_password" className="text-primary fw-semibold text-decoration-none">Forgot Password?</a>
                    </div>
                    
                    <button type="submit" className="btn btn-primary w-100 py-3 fw-bold mb-4">
                      Sign In
                    </button>
                    
                    <div className="text-center">
                      <p className="mb-0">Don't have an account? <a href="/register" className="text-primary fw-semibold">Register here</a></p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Login